(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    // Mantener el motor nativo, sin registrar ni almacenar búsquedas personales.
  if (!customElements.get('cdm-search-panel')) {
    customElements.define('cdm-search-panel', class extends HTMLElement {
      connectedCallback() {
        this.control = new AbortController();
        const opts = { signal:this.control.signal };
        this.input = this.querySelector('[name="q"]');
        this.stock = this.querySelector('[name="cdm-stock"]');
        this.grid = this.querySelector('.cdm-search__grid');
        this.status = this.querySelector('[role="status"]');
        this.all = this.querySelector('.cdm-search__all');
        this.clear = this.querySelector('.cdm-search__clear');
        const track=this.querySelector('.cdm-search__track');
        this.querySelectorAll('[data-carousel-step]').forEach(button=>button.addEventListener('click',()=>{
          track.scrollBy({left:Number(button.dataset.carouselStep)*Math.max(230,track.clientWidth*.8),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        },opts));
        track.addEventListener('scroll',()=>this.updateCarousel(),{...opts,passive:true});
        this.carouselObserver=new ResizeObserver(()=>this.updateCarousel());
        this.carouselObserver.observe(track);
        this.cache = new Map();
        this.sequence = 0;
        this.input.addEventListener('input', () => this.schedule(), opts);
        this.stock.addEventListener('change', () => this.schedule(), opts);
        this.clear.addEventListener('click', () => { this.input.value=''; this.schedule(); this.input.focus(); }, opts);
        this.addEventListener('click', event => {
          const chip = event.target.closest('[data-query]');
          if (!chip) return;
          this.input.value = chip.dataset.query;
          this.schedule();
          this.input.focus();
        }, opts);
        this.querySelector('form').addEventListener('submit', event => {
          const q = this.input.value.trim();
          if (!q) { event.preventDefault(); this.input.focus(); return; }
          const hidden = this.querySelector('[name="filter.v.availability"]');
          hidden?.remove();
          if (this.stock.checked) {
            const filter = document.createElement('input');
            filter.type='hidden'; filter.name='filter.v.availability'; filter.value='1';
            this.querySelector('form').append(filter);
          }
        }, opts);
        this.input.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            const first = this.grid.querySelector('a');
            if (first) { event.preventDefault(); first.focus(); }
          }
        }, opts);
        this.grid.addEventListener('keydown', event => {
          if(event.target.closest('select,button')) return;
          if (!['ArrowDown','ArrowUp'].includes(event.key)) return;
          const links = [...this.grid.querySelectorAll('a')];
          const index = links.indexOf(document.activeElement);
          const next = index + (event.key === 'ArrowDown' ? 1 : -1);
          event.preventDefault();
          if (next < 0) this.input.focus(); else links[Math.min(next,links.length-1)]?.focus();
        }, opts);
        this.closest('dialog-component').addEventListener('dialog:open', () => { this.schedule(); this.loadBestsellers(); this.input.focus(); }, opts);
        document.addEventListener('keydown', event => {
          if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase()==='k') {
            event.preventDefault(); this.closest('dialog-component').toggleDialog();
          }
        }, opts);
        this.closest('dialog').addEventListener('close', () => {
          clearTimeout(this.timer); this.fetcher?.abort(); this.sequence++;
          this.input.value=''; this.schedule();
          [...document.querySelectorAll('search-button button')].find(button=>button.getClientRects().length)?.focus();
        }, opts);
        this.schedule();
      }
      disconnectedCallback() {
        this.carouselObserver?.disconnect();
        this.control?.abort(); this.fetcher?.abort(); clearTimeout(this.timer);
      }
      updateCarousel() {
        const track=this.querySelector('.cdm-search__track');
        this.querySelector('[data-carousel-step="-1"]').disabled=track.scrollLeft<2;
        this.querySelector('[data-carousel-step="1"]').disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;
      }
      async loadBestsellers() {
        if(this.bestsellersLoaded) { this.updateCarousel(); return; }
        this.bestsellersLoaded=true;
        const track=this.querySelector('.cdm-search__track');
        try {
          const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
          const response=await fetch(root+'collections/all?sort_by=best-selling&filter.v.availability=1',{signal:AbortSignal.any([this.control.signal,AbortSignal.timeout(10000)])});
          if(!response.ok) throw Error('bestsellers');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const cards=[...doc.querySelectorAll('main product-card')].slice(0,8);
          if(!cards.length) throw Error('empty');
          const items=[];
          for(const card of cards) {
            const link=card.querySelector('a.product-card__link');
            const image=card.querySelector('img.product-media__image');
            if(!link||!image) continue;
            const url=new URL(link.getAttribute('href'),location.origin);
            if(url.origin!==location.origin) continue;
            const item=this.link(url.pathname+url.search,''); item.className='cdm-search__recommend-card';
            const img=document.createElement('img');
            const src=new URL(image.getAttribute('src'),location.origin); src.searchParams.set('width','160');
            img.src=src.href; img.alt=''; img.width=64; img.height=72; img.loading='lazy';
            const info=document.createElement('span');
            const title=document.createElement('strong'); title.textContent=link.textContent.trim();
            const price=document.createElement('small'); price.textContent=card.querySelector('.price')?.textContent.trim()||'';
            info.append(title,price); item.append(img,info); items.push(item);
          }
          if(!items.length) throw Error('empty');
          track.replaceChildren(...items);
        } catch(error) {
          track.hidden=true;
          this.querySelector('.cdm-search__recommend-fallback').hidden=false;
        } finally {
          track.removeAttribute('aria-busy'); this.updateCarousel();
        }
      }
      url(q) {
        const url = new URL(this.dataset.search, location.origin);
        url.searchParams.set('q',q); url.searchParams.set('type','product');
        if (this.stock.checked) url.searchParams.set('filter.v.availability','1');
        return url.pathname + url.search;
      }
      schedule() {
        clearTimeout(this.timer); this.fetcher?.abort(); this.sequence++;
        const q = this.input.value.trim();
        this.clear.hidden = !q;
        this.querySelector(".cdm-search__empty").hidden=true;
        this.querySelector('.cdm-search__welcome').hidden = !!q;
        this.querySelector('.cdm-search__result-heading').hidden = true;
        this.grid.replaceChildren(); this.status.textContent=''; this.status.classList.remove('is-success');
        this.grid.removeAttribute('aria-busy');
        this.all.hidden = !q;
        if(q) this.all.href = this.url(q);
        this.querySelector('.cdm-search__suggested').hidden = true;
        this.querySelector('.cdm-search__collections').hidden = true;
        if (!q) return;
        this.status.textContent='Buscando…';
        this.grid.setAttribute('aria-busy','true');
        const seq=this.sequence;
        this.timer=setTimeout(() => this.search(q,seq),220);
      }
      async search(q,seq) {
        const key=q.toLocaleLowerCase()+'|'+this.stock.checked;
        try {
          let data=this.cache.get(key);
          if (!data) {
            this.fetcher=new AbortController();
            const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
            const url=new URL(root+'search/suggest.json',location.origin);
            url.searchParams.set('q',q);
            url.searchParams.set('resources[type]','product,collection,query');
            url.searchParams.set('resources[limit]','6');
            url.searchParams.set('resources[limit_scope]','each');
            url.searchParams.set('resources[options][unavailable_products]',this.stock.checked?'hide':'last');
            const response=await fetch(url,{signal:AbortSignal.any([this.fetcher.signal,AbortSignal.timeout(10000)]),headers:{Accept:'application/json'}});
            if(!response.ok) throw Error('search');
            data=(await response.json()).resources.results;
            if(this.cache.size>=30) this.cache.delete(this.cache.keys().next().value);
            this.cache.set(key,data);
          }
          if(seq!==this.sequence||!this.isConnected) return;
          this.render(data);
        } catch(error) {
          if(error.name==='AbortError'||seq!==this.sequence) return;
          this.status.textContent='No hemos podido cargar las sugerencias. Pulsa «Ver todos los resultados» para continuar con tu búsqueda.';
        } finally {
          if(seq===this.sequence) this.grid.removeAttribute('aria-busy');
        }
      }

      // Consultar variantes al pulsar el botón; no se precargan seis fichas en cada búsqueda.
      async quickBuy(product, card, button, select, feedback) {
        if (button.dataset.busy==='true') return;
        button.dataset.busy='true';
        button.disabled=true;
        feedback.textContent='';
        const original=button.textContent;
        button.textContent='Un momento…';
        let confirmed=false;
        let posting=false;
        try {
          const root=this.dataset.root.endsWith('/')?this.dataset.root:this.dataset.root+'/';
          const response=await fetch(root+'products/'+encodeURIComponent(product.handle)+'.js',{
            headers:{Accept:'application/json'},signal:AbortSignal.timeout(10000)
          });
          if(!response.ok) throw Error('No pudimos consultar las opciones. Inténtalo de nuevo.');
          const detail=await response.json();
          if(!card.isConnected) return;
          const variants=detail.variants||[];
          if(detail.requires_selling_plan) throw Error('Este producto requiere opciones adicionales. Abre su ficha para elegirlas.');
          if(!variants.some(v=>v.available)) {
            button.dataset.soldout='true';
            button.textContent='Agotado';
            feedback.textContent='Este producto ya no está disponible.';
            return;
          }
          let variant;
          if(variants.length>1) {
            const chosen=select.value;
            const placeholder=document.createElement('option');
            placeholder.value=''; placeholder.textContent='Elige una opción'; placeholder.disabled=true;
            select.replaceChildren(placeholder);
            const money=new Intl.NumberFormat(this.dataset.locale||'es',{style:'currency',currency:this.dataset.currency||'EUR'});
            for(const item of variants) {
              const option=document.createElement('option');
              option.value=String(item.id); option.disabled=!item.available; option.dataset.price=String(item.price);
              option.textContent=item.title+' · '+money.format(item.price/100)+(item.available?'':' · Agotado');
              select.append(option);
            }
            select.value=variants.some(v=>String(v.id)===chosen&&v.available)?chosen:'';
            select.hidden=false;
            if(!select.value) {
              button.textContent='Añadir a la cesta';
              feedback.textContent='Selecciona la opción que prefieras.';
              select.focus();
              return;
            }
            variant=variants.find(v=>String(v.id)===select.value&&v.available);
          } else {
            variant=variants.find(v=>v.available);
          }
          if(!variant) throw Error('La opción elegida ya no está disponible.');
          // Cargar los eventos originales de Horizon antes de modificar el carrito.
          const { CartAddEvent }=await import(this.dataset.eventsUrl);
          const sections=[...new Set([...document.querySelectorAll('cart-items-component')]
            .map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
          const body={items:[{id:variant.id,quantity:1}],sections,sections_url:location.pathname+location.search};
          button.textContent='Añadiendo…';
          posting=true;
          const added=await fetch(root+'cart/add.js',{
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify(body)
          });
          const result=await added.json();
          if(!added.ok||result.status) {
            posting=false;
            throw Error(typeof result.description==='string'?result.description:'No se ha podido añadir esta opción. Comprueba su disponibilidad.');
          }
          confirmed=true;
          feedback.textContent='Añadido a la cesta.';
          button.textContent='Añadido ✓';
          // Cerrar primero el buscador para que no se superponga al carrito lateral.
          const dialog=this.closest('dialog-component');
          if(dialog?.querySelector('dialog')?.open) await dialog.closeDialog();
          document.dispatchEvent(new CartAddEvent({},String(variant.id),{
            source:'product-form-component',productId:String(detail.id),itemCount:1,
            variantId:String(variant.id),sections:result.sections
          }));
          document.querySelector('cart-drawer-component')?.open();
        } catch(error) {
          feedback.textContent=confirmed?'Añadido. Abre el carrito para comprobarlo.':
            posting?'No se pudo confirmar la operación. Revisa el carrito antes de volver a añadir.':
            error.name==='TimeoutError'?'La consulta ha tardado demasiado. Inténtalo de nuevo.':error.message;
          button.textContent=confirmed?'Añadido ✓':original;
        } finally {
          delete button.dataset.busy;
          button.disabled=button.dataset.soldout==='true';
          if(!confirmed&&button.dataset.soldout!=='true') button.textContent='Añadir a la cesta';
        }
      }

      link(url,text) {
        const a=document.createElement('a');
        const safe=new URL(url,location.origin);
        a.href=safe.origin===location.origin?safe.pathname+safe.search:this.url(this.input.value.trim());
        a.textContent=text;
        return a;
      }
      render(data) {
        const products=data.products||[];
        this.status.classList.toggle('is-success',products.length>0);
        this.grid.replaceChildren();
        this.status.textContent=products.length?'':'No encontramos productos para esta búsqueda.';
        this.querySelector('.cdm-search__empty').hidden=!!products.length;
        this.querySelector('.cdm-search__result-heading').hidden=!products.length;
        this.querySelector('[data-count]').textContent=products.length+' sugerencias';
        const money=new Intl.NumberFormat(this.dataset.locale||'es',{style:'currency',currency:this.dataset.currency||'EUR'});
        for(const p of products) {
          const card=document.createElement('article'); card.className='cdm-search__card';
          const productLink=this.link(p.url,''); productLink.className='cdm-search__product-link';
          const picture=document.createElement('div'); picture.className='cdm-search__image';
          const src=p.featured_image?.url||p.image;
          if(src) {
            const image=document.createElement('img');
            const imageUrl=new URL(src,location.origin); imageUrl.searchParams.set('width','300');
            image.src=imageUrl.href; image.alt=''; image.width=300; image.height=300; image.loading='lazy';
            picture.append(image);
          }
          productLink.append(picture);
          const vendor=document.createElement('span'); vendor.className='cdm-search__vendor'; vendor.textContent=p.vendor;
          const title=document.createElement('span'); title.className='cdm-search__name'; title.textContent=p.title;
          const price=document.createElement('span'); price.className='cdm-search__price';
          price.textContent=(Number(p.price_min)!==Number(p.price_max)?'Desde ':'')+money.format(Number(p.price_min??p.price));
          if(Number(p.price_min)===Number(p.price_max) && Number(p.compare_at_price_min)>Number(p.price_min??p.price)) {
            const old=document.createElement('del'); old.textContent=money.format(Number(p.compare_at_price_min)); price.append(old);
          }
          const available=document.createElement('span'); available.className='cdm-search__availability'+(p.available?'':' is-soldout');
          available.textContent=p.available?'Disponible':'Agotado';
          productLink.append(vendor,title,price,available); card.append(productLink);
          const buy=document.createElement('div'); buy.className='cdm-search__buy';
          const select=document.createElement('select'); select.className='cdm-search__variant'; select.hidden=true;
          select.setAttribute('aria-label','Elegir opción de '+p.title);
          const feedback=document.createElement('p'); feedback.className='cdm-search__cart-status';
          feedback.setAttribute('role','status'); feedback.setAttribute('aria-live','polite');
          const add=document.createElement('button'); add.type='button'; add.className='cdm-search__add';
          add.textContent=p.available?'Añadir a la cesta':'Agotado'; add.disabled=!p.available;
          add.setAttribute('aria-label',(p.available?'Añadir a la cesta: ':'Agotado: ')+p.title);
          add.addEventListener('click',()=>this.quickBuy(p,card,add,select,feedback));
          select.addEventListener('change',()=>{
            const chosen=select.selectedOptions[0];
            if(chosen&&!chosen.disabled) {
              feedback.textContent='Opción seleccionada. Pulsa Añadir a la cesta.';
              price.textContent=money.format(Number(chosen.dataset.price)/100);
              const selectedUrl=new URL(productLink.href,location.origin);
              selectedUrl.searchParams.set('variant',select.value);
              productLink.href=selectedUrl.pathname+selectedUrl.search;
            }
          });
          buy.append(select,add,feedback); card.append(buy); this.grid.append(card);
        }
        for(const [key,selector,container] of [['queries','[data-suggestions]','.cdm-search__suggested'],['collections','[data-collections]','.cdm-search__collections']]) {
          const target=this.querySelector(selector); target.replaceChildren();
          for(const item of (data[key]||[]).slice(0,4)) target.append(this.link(item.url,item.text||item.title));
          this.querySelector(container).hidden=!target.children.length;
        }
        if(products.length) this.status.textContent=products.length+' productos sugeridos. Puedes ver todos los resultados y más filtros al final.';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cdm-search-teaser')) {
    customElements.define('cdm-search-teaser',class extends HTMLElement {
      connectedCallback() {
        this.controller=new AbortController();
        const opts={signal:this.controller.signal};
        this.words=['condones sin látex','lubricantes','Durex y Unilatex','juguetes para descubrir'];
        this.word=0; this.position=this.words[0].length; this.deleting=true; this.paused=false;
        this.text=this.querySelector('[data-search-typed]');
        this.toggle=this.querySelector('.cdm-search-motion');
        this.motion=matchMedia('(prefers-reduced-motion: reduce)');
        this.toggle.addEventListener('click',event=>{
          event.preventDefault(); event.stopPropagation();
          this.paused=!this.paused;
          this.toggle.setAttribute('aria-pressed',String(this.paused));
          this.toggle.setAttribute('aria-label',this.paused?'Reanudar ejemplos de búsqueda':'Pausar ejemplos de búsqueda');
          this.toggle.title=this.paused?'Reanudar ejemplos':'Pausar ejemplos';
          this.toggle.querySelector('span').textContent=this.paused?'Reanudar animación':'Pausar animación';
          this.restart();
        },opts);
        document.addEventListener('visibilitychange',()=>this.restart(),opts);
        this.motion.addEventListener('change',()=>this.restart(),opts);
        this.addEventListener('mouseenter',()=>{this.hovering=true;this.restart();},opts);
        this.addEventListener('mouseleave',()=>{this.hovering=false;this.restart();},opts);
        this.addEventListener('focusin',()=>{this.focused=true;this.restart();},opts);
        this.addEventListener('focusout',event=>{if(!this.contains(event.relatedTarget)){this.focused=false;this.restart();}},opts);
        this.resizeObserver=new ResizeObserver(()=>this.restart());
        this.resizeObserver.observe(this);
        this.restart();
      }
      restart() {
        clearTimeout(this.timer);
        if(this.motion.matches) {this.text.textContent='productos y marcas';this.toggle.hidden=true;return;}
        this.toggle.hidden=false;
        if(this.paused||document.hidden||this.hovering||this.focused||!this.getClientRects().length) return;
        this.text.textContent=this.words[this.word].slice(0,this.position);
        this.timer=setTimeout(()=>this.tick(),1800);
      }
      tick() {
        if(!this.isConnected||this.paused||document.hidden) return;
        const current=this.words[this.word];
        this.position+=this.deleting?-1:1;
        this.text.textContent=current.slice(0,this.position);
        let delay=this.deleting?40:85;
        if(this.position<=0) {this.word=(this.word+1)%this.words.length;this.deleting=false;delay=300;}
        else if(this.position>=current.length) {this.deleting=true;delay=2200;}
        this.timer=setTimeout(()=>this.tick(),delay);
      }
      disconnectedCallback() {this.resizeObserver?.disconnect();clearTimeout(this.timer);this.controller?.abort();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
